import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import brand from './lib/brand';

document.title = `${brand.name} Merchant`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
